// source: core/protos/geometry.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.vertexvis.protobuf.core.AffineMatrix4d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.AffineMatrix4f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.AffineTransform2d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.AffineTransform2f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.AffineTransform3d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.AffineTransform3f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.BBox2d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.BBox2f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.BBox2i', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.BBox3d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.BBox3f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.BoundingBox3f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Dimension2i', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Indexed3DTriangleSet', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.IndexedVector3fArray', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.LinearTransform2d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.LinearTransform2f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.LinearTransform3d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.LinearTransform3f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Matrix4x4d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Matrix4x4f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Plane', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Point2i', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Vector2d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Vector2f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Vector2i', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Vector3d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Vector3f', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Vector4d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Vector4f', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Vector2i = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Vector2i, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Vector2i.displayName = 'proto.vertexvis.protobuf.core.Vector2i';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Vector2f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Vector2f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Vector2f.displayName = 'proto.vertexvis.protobuf.core.Vector2f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Vector2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Vector2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Vector2d.displayName = 'proto.vertexvis.protobuf.core.Vector2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Vector3f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Vector3f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Vector3f.displayName = 'proto.vertexvis.protobuf.core.Vector3f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Vector3d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Vector3d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Vector3d.displayName = 'proto.vertexvis.protobuf.core.Vector3d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Vector4f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Vector4f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Vector4f.displayName = 'proto.vertexvis.protobuf.core.Vector4f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Vector4d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Vector4d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Vector4d.displayName = 'proto.vertexvis.protobuf.core.Vector4d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.BoundingBox3f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.BoundingBox3f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.BoundingBox3f.displayName = 'proto.vertexvis.protobuf.core.BoundingBox3f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.AffineMatrix4f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.AffineMatrix4f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.AffineMatrix4f.displayName = 'proto.vertexvis.protobuf.core.AffineMatrix4f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.AffineMatrix4d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.AffineMatrix4d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.AffineMatrix4d.displayName = 'proto.vertexvis.protobuf.core.AffineMatrix4d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.core.IndexedVector3fArray.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.core.IndexedVector3fArray, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.IndexedVector3fArray.displayName = 'proto.vertexvis.protobuf.core.IndexedVector3fArray';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Indexed3DTriangleSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Indexed3DTriangleSet.displayName = 'proto.vertexvis.protobuf.core.Indexed3DTriangleSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Matrix4x4f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Matrix4x4f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Matrix4x4f.displayName = 'proto.vertexvis.protobuf.core.Matrix4x4f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Matrix4x4d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Matrix4x4d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Matrix4x4d.displayName = 'proto.vertexvis.protobuf.core.Matrix4x4d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Dimension2i = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Dimension2i, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Dimension2i.displayName = 'proto.vertexvis.protobuf.core.Dimension2i';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Point2i = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Point2i, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Point2i.displayName = 'proto.vertexvis.protobuf.core.Point2i';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.BBox2f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.BBox2f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.BBox2f.displayName = 'proto.vertexvis.protobuf.core.BBox2f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.BBox2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.BBox2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.BBox2d.displayName = 'proto.vertexvis.protobuf.core.BBox2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.BBox2i = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.BBox2i, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.BBox2i.displayName = 'proto.vertexvis.protobuf.core.BBox2i';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.BBox3f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.BBox3f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.BBox3f.displayName = 'proto.vertexvis.protobuf.core.BBox3f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.BBox3d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.BBox3d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.BBox3d.displayName = 'proto.vertexvis.protobuf.core.BBox3d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.LinearTransform2f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.LinearTransform2f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.LinearTransform2f.displayName = 'proto.vertexvis.protobuf.core.LinearTransform2f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.LinearTransform2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.LinearTransform2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.LinearTransform2d.displayName = 'proto.vertexvis.protobuf.core.LinearTransform2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.LinearTransform3f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.LinearTransform3f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.LinearTransform3f.displayName = 'proto.vertexvis.protobuf.core.LinearTransform3f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.LinearTransform3d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.LinearTransform3d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.LinearTransform3d.displayName = 'proto.vertexvis.protobuf.core.LinearTransform3d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.AffineTransform2f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.AffineTransform2f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.AffineTransform2f.displayName = 'proto.vertexvis.protobuf.core.AffineTransform2f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.AffineTransform2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.AffineTransform2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.AffineTransform2d.displayName = 'proto.vertexvis.protobuf.core.AffineTransform2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.AffineTransform3f = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.AffineTransform3f, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.AffineTransform3f.displayName = 'proto.vertexvis.protobuf.core.AffineTransform3f';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.AffineTransform3d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.AffineTransform3d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.AffineTransform3d.displayName = 'proto.vertexvis.protobuf.core.AffineTransform3d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Plane = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Plane, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Plane.displayName = 'proto.vertexvis.protobuf.core.Plane';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Vector2i.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Vector2i.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Vector2i} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector2i.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFieldWithDefault(msg, 1, 0),
    y: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Vector2i}
 */
proto.vertexvis.protobuf.core.Vector2i.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Vector2i;
  return proto.vertexvis.protobuf.core.Vector2i.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Vector2i} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Vector2i}
 */
proto.vertexvis.protobuf.core.Vector2i.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Vector2i.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Vector2i.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Vector2i} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector2i.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 x = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector2i.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector2i} returns this
 */
proto.vertexvis.protobuf.core.Vector2i.prototype.setX = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 y = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector2i.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector2i} returns this
 */
proto.vertexvis.protobuf.core.Vector2i.prototype.setY = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Vector2f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Vector2f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Vector2f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector2f.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Vector2f}
 */
proto.vertexvis.protobuf.core.Vector2f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Vector2f;
  return proto.vertexvis.protobuf.core.Vector2f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Vector2f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Vector2f}
 */
proto.vertexvis.protobuf.core.Vector2f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Vector2f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Vector2f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Vector2f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector2f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional float x = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector2f.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector2f} returns this
 */
proto.vertexvis.protobuf.core.Vector2f.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float y = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector2f.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector2f} returns this
 */
proto.vertexvis.protobuf.core.Vector2f.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Vector2d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Vector2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Vector2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector2d.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.Vector2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Vector2d;
  return proto.vertexvis.protobuf.core.Vector2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Vector2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.Vector2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Vector2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Vector2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Vector2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector2d.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector2d} returns this
 */
proto.vertexvis.protobuf.core.Vector2d.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector2d.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector2d} returns this
 */
proto.vertexvis.protobuf.core.Vector2d.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Vector3f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Vector3f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Vector3f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector3f.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    z: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.Vector3f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Vector3f;
  return proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Vector3f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Vector3f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Vector3f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getZ();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional float x = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector3f.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector3f} returns this
 */
proto.vertexvis.protobuf.core.Vector3f.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float y = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector3f.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector3f} returns this
 */
proto.vertexvis.protobuf.core.Vector3f.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float z = 3;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector3f.prototype.getZ = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector3f} returns this
 */
proto.vertexvis.protobuf.core.Vector3f.prototype.setZ = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Vector3d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Vector3d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Vector3d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector3d.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    z: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.Vector3d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Vector3d;
  return proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Vector3d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Vector3d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Vector3d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getZ();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector3d.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector3d} returns this
 */
proto.vertexvis.protobuf.core.Vector3d.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector3d.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector3d} returns this
 */
proto.vertexvis.protobuf.core.Vector3d.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double z = 3;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector3d.prototype.getZ = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector3d} returns this
 */
proto.vertexvis.protobuf.core.Vector3d.prototype.setZ = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Vector4f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Vector4f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector4f.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    z: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    w: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Vector4f}
 */
proto.vertexvis.protobuf.core.Vector4f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Vector4f;
  return proto.vertexvis.protobuf.core.Vector4f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Vector4f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Vector4f}
 */
proto.vertexvis.protobuf.core.Vector4f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setZ(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setW(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Vector4f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Vector4f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector4f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getZ();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getW();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * optional float x = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector4f} returns this
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float y = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector4f} returns this
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float z = 3;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.getZ = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector4f} returns this
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.setZ = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float w = 4;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.getW = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector4f} returns this
 */
proto.vertexvis.protobuf.core.Vector4f.prototype.setW = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Vector4d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Vector4d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector4d.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    z: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    w: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Vector4d}
 */
proto.vertexvis.protobuf.core.Vector4d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Vector4d;
  return proto.vertexvis.protobuf.core.Vector4d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Vector4d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Vector4d}
 */
proto.vertexvis.protobuf.core.Vector4d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setZ(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setW(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Vector4d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Vector4d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Vector4d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getZ();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getW();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector4d} returns this
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector4d} returns this
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double z = 3;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.getZ = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector4d} returns this
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.setZ = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double w = 4;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.getW = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Vector4d} returns this
 */
proto.vertexvis.protobuf.core.Vector4d.prototype.setW = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.BoundingBox3f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.BoundingBox3f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BoundingBox3f.toObject = function(includeInstance, msg) {
  var f, obj = {
    xmin: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    xmax: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    ymin: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    ymax: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    zmin: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    zmax: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.BoundingBox3f}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.BoundingBox3f;
  return proto.vertexvis.protobuf.core.BoundingBox3f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.BoundingBox3f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.BoundingBox3f}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setXmin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setXmax(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setYmin(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setYmax(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setZmin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setZmax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.BoundingBox3f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.BoundingBox3f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BoundingBox3f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getXmin();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getXmax();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getYmin();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getYmax();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getZmin();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getZmax();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
};


/**
 * optional float xmin = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.getXmin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.BoundingBox3f} returns this
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.setXmin = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float xmax = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.getXmax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.BoundingBox3f} returns this
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.setXmax = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float ymin = 3;
 * @return {number}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.getYmin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.BoundingBox3f} returns this
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.setYmin = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float ymax = 4;
 * @return {number}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.getYmax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.BoundingBox3f} returns this
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.setYmax = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float zmin = 5;
 * @return {number}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.getZmin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.BoundingBox3f} returns this
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.setZmin = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float zmax = 6;
 * @return {number}
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.getZmax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.BoundingBox3f} returns this
 */
proto.vertexvis.protobuf.core.BoundingBox3f.prototype.setZmax = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.AffineMatrix4f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.AffineMatrix4f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.toObject = function(includeInstance, msg) {
  var f, obj = {
    basisX: (f = msg.getBasisX()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f),
    basisY: (f = msg.getBasisY()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f),
    xlate: (f = msg.getXlate()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f),
    scale: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    basisZ: (f = msg.getBasisZ()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.AffineMatrix4f;
  return proto.vertexvis.protobuf.core.AffineMatrix4f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.AffineMatrix4f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setBasisX(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setBasisY(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setXlate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScale(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setBasisZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.AffineMatrix4f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.AffineMatrix4f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasisX();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getBasisY();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getXlate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getScale();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getBasisZ();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector3f basis_x = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.getBasisX = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f} returns this
*/
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.setBasisX = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.clearBasisX = function() {
  return this.setBasisX(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.hasBasisX = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3f basis_y = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.getBasisY = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f} returns this
*/
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.setBasisY = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.clearBasisY = function() {
  return this.setBasisY(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.hasBasisY = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3f xlate = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.getXlate = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f} returns this
*/
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.setXlate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.clearXlate = function() {
  return this.setXlate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.hasXlate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float scale = 4;
 * @return {number}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.getScale = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.setScale = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional Vector3f basis_z = 5;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.getBasisZ = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f} returns this
*/
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.setBasisZ = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4f} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.clearBasisZ = function() {
  return this.setBasisZ(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineMatrix4f.prototype.hasBasisZ = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.AffineMatrix4d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.AffineMatrix4d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.toObject = function(includeInstance, msg) {
  var f, obj = {
    basisX: (f = msg.getBasisX()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f),
    basisY: (f = msg.getBasisY()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f),
    xlate: (f = msg.getXlate()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f),
    scale: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    basisZ: (f = msg.getBasisZ()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.AffineMatrix4d;
  return proto.vertexvis.protobuf.core.AffineMatrix4d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.AffineMatrix4d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setBasisX(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setBasisY(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setXlate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScale(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setBasisZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.AffineMatrix4d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.AffineMatrix4d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasisX();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getBasisY();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getXlate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getScale();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getBasisZ();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector3d basis_x = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.getBasisX = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d} returns this
*/
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.setBasisX = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.clearBasisX = function() {
  return this.setBasisX(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.hasBasisX = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3d basis_y = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.getBasisY = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d} returns this
*/
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.setBasisY = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.clearBasisY = function() {
  return this.setBasisY(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.hasBasisY = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3d xlate = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.getXlate = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d} returns this
*/
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.setXlate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.clearXlate = function() {
  return this.setXlate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.hasXlate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional double scale = 4;
 * @return {number}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.getScale = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.setScale = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional Vector3d basis_z = 5;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.getBasisZ = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d} returns this
*/
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.setBasisZ = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineMatrix4d} returns this
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.clearBasisZ = function() {
  return this.setBasisZ(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineMatrix4d.prototype.hasBasisZ = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.IndexedVector3fArray.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.IndexedVector3fArray} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    proto.vertexvis.protobuf.core.Vector3f.toObject, includeInstance),
    indicesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.IndexedVector3fArray}
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.IndexedVector3fArray;
  return proto.vertexvis.protobuf.core.IndexedVector3fArray.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.IndexedVector3fArray} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.IndexedVector3fArray}
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedUint32());
      msg.setIndicesList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.IndexedVector3fArray.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.IndexedVector3fArray} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getIndicesList();
  if (f.length > 0) {
    writer.writePackedUint32(
      2,
      f
    );
  }
};


/**
 * repeated Vector3f values = 1;
 * @return {!Array<!proto.vertexvis.protobuf.core.Vector3f>}
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.core.Vector3f>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.core.Vector3f>} value
 * @return {!proto.vertexvis.protobuf.core.IndexedVector3fArray} returns this
*/
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.core.Vector3f=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.core.Vector3f, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.core.IndexedVector3fArray} returns this
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * repeated uint32 indices = 2;
 * @return {!Array<number>}
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.getIndicesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.vertexvis.protobuf.core.IndexedVector3fArray} returns this
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.setIndicesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.core.IndexedVector3fArray} returns this
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.addIndices = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.core.IndexedVector3fArray} returns this
 */
proto.vertexvis.protobuf.core.IndexedVector3fArray.prototype.clearIndicesList = function() {
  return this.setIndicesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Indexed3DTriangleSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Indexed3DTriangleSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    vertices: (f = msg.getVertices()) && proto.vertexvis.protobuf.core.IndexedVector3fArray.toObject(includeInstance, f),
    normals: (f = msg.getNormals()) && proto.vertexvis.protobuf.core.IndexedVector3fArray.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Indexed3DTriangleSet}
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Indexed3DTriangleSet;
  return proto.vertexvis.protobuf.core.Indexed3DTriangleSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Indexed3DTriangleSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Indexed3DTriangleSet}
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.IndexedVector3fArray;
      reader.readMessage(value,proto.vertexvis.protobuf.core.IndexedVector3fArray.deserializeBinaryFromReader);
      msg.setVertices(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.IndexedVector3fArray;
      reader.readMessage(value,proto.vertexvis.protobuf.core.IndexedVector3fArray.deserializeBinaryFromReader);
      msg.setNormals(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Indexed3DTriangleSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Indexed3DTriangleSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVertices();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.IndexedVector3fArray.serializeBinaryToWriter
    );
  }
  f = message.getNormals();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.IndexedVector3fArray.serializeBinaryToWriter
    );
  }
};


/**
 * optional IndexedVector3fArray vertices = 1;
 * @return {?proto.vertexvis.protobuf.core.IndexedVector3fArray}
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.getVertices = function() {
  return /** @type{?proto.vertexvis.protobuf.core.IndexedVector3fArray} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.IndexedVector3fArray, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.IndexedVector3fArray|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Indexed3DTriangleSet} returns this
*/
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.setVertices = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Indexed3DTriangleSet} returns this
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.clearVertices = function() {
  return this.setVertices(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.hasVertices = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IndexedVector3fArray normals = 2;
 * @return {?proto.vertexvis.protobuf.core.IndexedVector3fArray}
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.getNormals = function() {
  return /** @type{?proto.vertexvis.protobuf.core.IndexedVector3fArray} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.IndexedVector3fArray, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.IndexedVector3fArray|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Indexed3DTriangleSet} returns this
*/
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.setNormals = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Indexed3DTriangleSet} returns this
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.clearNormals = function() {
  return this.setNormals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Indexed3DTriangleSet.prototype.hasNormals = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Matrix4x4f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Matrix4x4f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Matrix4x4f.toObject = function(includeInstance, msg) {
  var f, obj = {
    r0: (f = msg.getR0()) && proto.vertexvis.protobuf.core.Vector4f.toObject(includeInstance, f),
    r1: (f = msg.getR1()) && proto.vertexvis.protobuf.core.Vector4f.toObject(includeInstance, f),
    r2: (f = msg.getR2()) && proto.vertexvis.protobuf.core.Vector4f.toObject(includeInstance, f),
    r3: (f = msg.getR3()) && proto.vertexvis.protobuf.core.Vector4f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Matrix4x4f;
  return proto.vertexvis.protobuf.core.Matrix4x4f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Matrix4x4f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector4f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector4f.deserializeBinaryFromReader);
      msg.setR0(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector4f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector4f.deserializeBinaryFromReader);
      msg.setR1(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.Vector4f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector4f.deserializeBinaryFromReader);
      msg.setR2(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.core.Vector4f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector4f.deserializeBinaryFromReader);
      msg.setR3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Matrix4x4f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Matrix4x4f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Matrix4x4f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getR0();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector4f.serializeBinaryToWriter
    );
  }
  f = message.getR1();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector4f.serializeBinaryToWriter
    );
  }
  f = message.getR2();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.Vector4f.serializeBinaryToWriter
    );
  }
  f = message.getR3();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.core.Vector4f.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector4f r0 = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector4f}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.getR0 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector4f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector4f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector4f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f} returns this
*/
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.setR0 = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f} returns this
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.clearR0 = function() {
  return this.setR0(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.hasR0 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector4f r1 = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector4f}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.getR1 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector4f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector4f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector4f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f} returns this
*/
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.setR1 = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f} returns this
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.clearR1 = function() {
  return this.setR1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.hasR1 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector4f r2 = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector4f}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.getR2 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector4f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector4f, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector4f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f} returns this
*/
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.setR2 = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f} returns this
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.clearR2 = function() {
  return this.setR2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.hasR2 = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Vector4f r3 = 4;
 * @return {?proto.vertexvis.protobuf.core.Vector4f}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.getR3 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector4f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector4f, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector4f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f} returns this
*/
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.setR3 = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4f} returns this
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.clearR3 = function() {
  return this.setR3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Matrix4x4f.prototype.hasR3 = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Matrix4x4d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Matrix4x4d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Matrix4x4d.toObject = function(includeInstance, msg) {
  var f, obj = {
    r0: (f = msg.getR0()) && proto.vertexvis.protobuf.core.Vector4d.toObject(includeInstance, f),
    r1: (f = msg.getR1()) && proto.vertexvis.protobuf.core.Vector4d.toObject(includeInstance, f),
    r2: (f = msg.getR2()) && proto.vertexvis.protobuf.core.Vector4d.toObject(includeInstance, f),
    r3: (f = msg.getR3()) && proto.vertexvis.protobuf.core.Vector4d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Matrix4x4d;
  return proto.vertexvis.protobuf.core.Matrix4x4d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Matrix4x4d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector4d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector4d.deserializeBinaryFromReader);
      msg.setR0(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector4d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector4d.deserializeBinaryFromReader);
      msg.setR1(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.Vector4d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector4d.deserializeBinaryFromReader);
      msg.setR2(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.core.Vector4d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector4d.deserializeBinaryFromReader);
      msg.setR3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Matrix4x4d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Matrix4x4d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Matrix4x4d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getR0();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector4d.serializeBinaryToWriter
    );
  }
  f = message.getR1();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector4d.serializeBinaryToWriter
    );
  }
  f = message.getR2();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.Vector4d.serializeBinaryToWriter
    );
  }
  f = message.getR3();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.core.Vector4d.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector4d r0 = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector4d}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.getR0 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector4d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector4d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector4d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d} returns this
*/
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.setR0 = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d} returns this
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.clearR0 = function() {
  return this.setR0(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.hasR0 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector4d r1 = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector4d}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.getR1 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector4d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector4d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector4d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d} returns this
*/
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.setR1 = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d} returns this
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.clearR1 = function() {
  return this.setR1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.hasR1 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector4d r2 = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector4d}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.getR2 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector4d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector4d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector4d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d} returns this
*/
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.setR2 = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d} returns this
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.clearR2 = function() {
  return this.setR2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.hasR2 = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Vector4d r3 = 4;
 * @return {?proto.vertexvis.protobuf.core.Vector4d}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.getR3 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector4d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector4d, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector4d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d} returns this
*/
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.setR3 = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Matrix4x4d} returns this
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.clearR3 = function() {
  return this.setR3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Matrix4x4d.prototype.hasR3 = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Dimension2i.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Dimension2i.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Dimension2i} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Dimension2i.toObject = function(includeInstance, msg) {
  var f, obj = {
    width: jspb.Message.getFieldWithDefault(msg, 1, 0),
    height: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Dimension2i}
 */
proto.vertexvis.protobuf.core.Dimension2i.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Dimension2i;
  return proto.vertexvis.protobuf.core.Dimension2i.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Dimension2i} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Dimension2i}
 */
proto.vertexvis.protobuf.core.Dimension2i.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Dimension2i.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Dimension2i.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Dimension2i} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Dimension2i.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 width = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Dimension2i.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Dimension2i} returns this
 */
proto.vertexvis.protobuf.core.Dimension2i.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 height = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Dimension2i.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Dimension2i} returns this
 */
proto.vertexvis.protobuf.core.Dimension2i.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Point2i.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Point2i.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Point2i} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Point2i.toObject = function(includeInstance, msg) {
  var f, obj = {
    dx: jspb.Message.getFieldWithDefault(msg, 1, 0),
    dy: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Point2i}
 */
proto.vertexvis.protobuf.core.Point2i.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Point2i;
  return proto.vertexvis.protobuf.core.Point2i.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Point2i} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Point2i}
 */
proto.vertexvis.protobuf.core.Point2i.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDx(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Point2i.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Point2i.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Point2i} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Point2i.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDx();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDy();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 dx = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Point2i.prototype.getDx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Point2i} returns this
 */
proto.vertexvis.protobuf.core.Point2i.prototype.setDx = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 dy = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Point2i.prototype.getDy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Point2i} returns this
 */
proto.vertexvis.protobuf.core.Point2i.prototype.setDy = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.BBox2f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.BBox2f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.BBox2f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox2f.toObject = function(includeInstance, msg) {
  var f, obj = {
    min: (f = msg.getMin()) && proto.vertexvis.protobuf.core.Vector2f.toObject(includeInstance, f),
    max: (f = msg.getMax()) && proto.vertexvis.protobuf.core.Vector2f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.BBox2f}
 */
proto.vertexvis.protobuf.core.BBox2f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.BBox2f;
  return proto.vertexvis.protobuf.core.BBox2f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.BBox2f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.BBox2f}
 */
proto.vertexvis.protobuf.core.BBox2f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector2f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2f.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector2f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2f.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.BBox2f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.BBox2f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.BBox2f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox2f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector2f.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector2f.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector2f min = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector2f}
 */
proto.vertexvis.protobuf.core.BBox2f.prototype.getMin = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox2f} returns this
*/
proto.vertexvis.protobuf.core.BBox2f.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox2f} returns this
 */
proto.vertexvis.protobuf.core.BBox2f.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox2f.prototype.hasMin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector2f max = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector2f}
 */
proto.vertexvis.protobuf.core.BBox2f.prototype.getMax = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox2f} returns this
*/
proto.vertexvis.protobuf.core.BBox2f.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox2f} returns this
 */
proto.vertexvis.protobuf.core.BBox2f.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox2f.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.BBox2d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.BBox2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.BBox2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox2d.toObject = function(includeInstance, msg) {
  var f, obj = {
    min: (f = msg.getMin()) && proto.vertexvis.protobuf.core.Vector2d.toObject(includeInstance, f),
    max: (f = msg.getMax()) && proto.vertexvis.protobuf.core.Vector2d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.BBox2d}
 */
proto.vertexvis.protobuf.core.BBox2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.BBox2d;
  return proto.vertexvis.protobuf.core.BBox2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.BBox2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.BBox2d}
 */
proto.vertexvis.protobuf.core.BBox2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2d.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2d.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.BBox2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.BBox2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.BBox2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector2d.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector2d.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector2d min = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.BBox2d.prototype.getMin = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox2d} returns this
*/
proto.vertexvis.protobuf.core.BBox2d.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox2d} returns this
 */
proto.vertexvis.protobuf.core.BBox2d.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox2d.prototype.hasMin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector2d max = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.BBox2d.prototype.getMax = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox2d} returns this
*/
proto.vertexvis.protobuf.core.BBox2d.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox2d} returns this
 */
proto.vertexvis.protobuf.core.BBox2d.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox2d.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.BBox2i.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.BBox2i.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.BBox2i} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox2i.toObject = function(includeInstance, msg) {
  var f, obj = {
    min: (f = msg.getMin()) && proto.vertexvis.protobuf.core.Vector2i.toObject(includeInstance, f),
    max: (f = msg.getMax()) && proto.vertexvis.protobuf.core.Vector2i.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.BBox2i}
 */
proto.vertexvis.protobuf.core.BBox2i.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.BBox2i;
  return proto.vertexvis.protobuf.core.BBox2i.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.BBox2i} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.BBox2i}
 */
proto.vertexvis.protobuf.core.BBox2i.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector2i;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2i.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector2i;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2i.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.BBox2i.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.BBox2i.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.BBox2i} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox2i.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector2i.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector2i.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector2i min = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector2i}
 */
proto.vertexvis.protobuf.core.BBox2i.prototype.getMin = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2i} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2i, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2i|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox2i} returns this
*/
proto.vertexvis.protobuf.core.BBox2i.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox2i} returns this
 */
proto.vertexvis.protobuf.core.BBox2i.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox2i.prototype.hasMin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector2i max = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector2i}
 */
proto.vertexvis.protobuf.core.BBox2i.prototype.getMax = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2i} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2i, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2i|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox2i} returns this
*/
proto.vertexvis.protobuf.core.BBox2i.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox2i} returns this
 */
proto.vertexvis.protobuf.core.BBox2i.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox2i.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.BBox3f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.BBox3f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.BBox3f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox3f.toObject = function(includeInstance, msg) {
  var f, obj = {
    min: (f = msg.getMin()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f),
    max: (f = msg.getMax()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.BBox3f}
 */
proto.vertexvis.protobuf.core.BBox3f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.BBox3f;
  return proto.vertexvis.protobuf.core.BBox3f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.BBox3f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.BBox3f}
 */
proto.vertexvis.protobuf.core.BBox3f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.BBox3f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.BBox3f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.BBox3f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox3f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector3f min = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.BBox3f.prototype.getMin = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox3f} returns this
*/
proto.vertexvis.protobuf.core.BBox3f.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox3f} returns this
 */
proto.vertexvis.protobuf.core.BBox3f.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox3f.prototype.hasMin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3f max = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.BBox3f.prototype.getMax = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox3f} returns this
*/
proto.vertexvis.protobuf.core.BBox3f.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox3f} returns this
 */
proto.vertexvis.protobuf.core.BBox3f.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox3f.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.BBox3d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.BBox3d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.BBox3d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox3d.toObject = function(includeInstance, msg) {
  var f, obj = {
    min: (f = msg.getMin()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f),
    max: (f = msg.getMax()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.BBox3d}
 */
proto.vertexvis.protobuf.core.BBox3d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.BBox3d;
  return proto.vertexvis.protobuf.core.BBox3d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.BBox3d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.BBox3d}
 */
proto.vertexvis.protobuf.core.BBox3d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.BBox3d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.BBox3d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.BBox3d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BBox3d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector3d min = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.BBox3d.prototype.getMin = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox3d} returns this
*/
proto.vertexvis.protobuf.core.BBox3d.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox3d} returns this
 */
proto.vertexvis.protobuf.core.BBox3d.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox3d.prototype.hasMin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3d max = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.BBox3d.prototype.getMax = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BBox3d} returns this
*/
proto.vertexvis.protobuf.core.BBox3d.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BBox3d} returns this
 */
proto.vertexvis.protobuf.core.BBox3d.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BBox3d.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.LinearTransform2f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.LinearTransform2f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LinearTransform2f.toObject = function(includeInstance, msg) {
  var f, obj = {
    basisX: (f = msg.getBasisX()) && proto.vertexvis.protobuf.core.Vector2f.toObject(includeInstance, f),
    basisY: (f = msg.getBasisY()) && proto.vertexvis.protobuf.core.Vector2f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2f}
 */
proto.vertexvis.protobuf.core.LinearTransform2f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.LinearTransform2f;
  return proto.vertexvis.protobuf.core.LinearTransform2f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.LinearTransform2f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2f}
 */
proto.vertexvis.protobuf.core.LinearTransform2f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector2f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2f.deserializeBinaryFromReader);
      msg.setBasisX(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector2f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2f.deserializeBinaryFromReader);
      msg.setBasisY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.LinearTransform2f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.LinearTransform2f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LinearTransform2f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasisX();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector2f.serializeBinaryToWriter
    );
  }
  f = message.getBasisY();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector2f.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector2f basis_x = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector2f}
 */
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.getBasisX = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2f} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.setBasisX = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2f} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.clearBasisX = function() {
  return this.setBasisX(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.hasBasisX = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector2f basis_y = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector2f}
 */
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.getBasisY = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2f} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.setBasisY = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2f} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.clearBasisY = function() {
  return this.setBasisY(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform2f.prototype.hasBasisY = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.LinearTransform2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.LinearTransform2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LinearTransform2d.toObject = function(includeInstance, msg) {
  var f, obj = {
    basisX: (f = msg.getBasisX()) && proto.vertexvis.protobuf.core.Vector2d.toObject(includeInstance, f),
    basisY: (f = msg.getBasisY()) && proto.vertexvis.protobuf.core.Vector2d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2d}
 */
proto.vertexvis.protobuf.core.LinearTransform2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.LinearTransform2d;
  return proto.vertexvis.protobuf.core.LinearTransform2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.LinearTransform2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2d}
 */
proto.vertexvis.protobuf.core.LinearTransform2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2d.deserializeBinaryFromReader);
      msg.setBasisX(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2d.deserializeBinaryFromReader);
      msg.setBasisY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.LinearTransform2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.LinearTransform2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LinearTransform2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasisX();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector2d.serializeBinaryToWriter
    );
  }
  f = message.getBasisY();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector2d.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector2d basis_x = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.getBasisX = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2d} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.setBasisX = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2d} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.clearBasisX = function() {
  return this.setBasisX(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.hasBasisX = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector2d basis_y = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.getBasisY = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2d} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.setBasisY = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform2d} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.clearBasisY = function() {
  return this.setBasisY(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform2d.prototype.hasBasisY = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.LinearTransform3f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.LinearTransform3f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LinearTransform3f.toObject = function(includeInstance, msg) {
  var f, obj = {
    basisX: (f = msg.getBasisX()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f),
    basisY: (f = msg.getBasisY()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f),
    basisZ: (f = msg.getBasisZ()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3f}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.LinearTransform3f;
  return proto.vertexvis.protobuf.core.LinearTransform3f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.LinearTransform3f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3f}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setBasisX(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setBasisY(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setBasisZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.LinearTransform3f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.LinearTransform3f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LinearTransform3f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasisX();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getBasisY();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getBasisZ();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector3f basis_x = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.getBasisX = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3f} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.setBasisX = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3f} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.clearBasisX = function() {
  return this.setBasisX(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.hasBasisX = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3f basis_y = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.getBasisY = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3f} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.setBasisY = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3f} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.clearBasisY = function() {
  return this.setBasisY(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.hasBasisY = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3f basis_z = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.getBasisZ = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3f} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.setBasisZ = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3f} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.clearBasisZ = function() {
  return this.setBasisZ(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform3f.prototype.hasBasisZ = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.LinearTransform3d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.LinearTransform3d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LinearTransform3d.toObject = function(includeInstance, msg) {
  var f, obj = {
    basisX: (f = msg.getBasisX()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f),
    basisY: (f = msg.getBasisY()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f),
    basisZ: (f = msg.getBasisZ()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3d}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.LinearTransform3d;
  return proto.vertexvis.protobuf.core.LinearTransform3d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.LinearTransform3d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3d}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setBasisX(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setBasisY(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setBasisZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.LinearTransform3d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.LinearTransform3d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LinearTransform3d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasisX();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getBasisY();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getBasisZ();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector3d basis_x = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.getBasisX = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3d} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.setBasisX = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3d} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.clearBasisX = function() {
  return this.setBasisX(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.hasBasisX = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3d basis_y = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.getBasisY = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3d} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.setBasisY = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3d} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.clearBasisY = function() {
  return this.setBasisY(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.hasBasisY = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3d basis_z = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.getBasisZ = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3d} returns this
*/
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.setBasisZ = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LinearTransform3d} returns this
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.clearBasisZ = function() {
  return this.setBasisZ(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LinearTransform3d.prototype.hasBasisZ = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.AffineTransform2f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.AffineTransform2f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineTransform2f.toObject = function(includeInstance, msg) {
  var f, obj = {
    transform: (f = msg.getTransform()) && proto.vertexvis.protobuf.core.LinearTransform2f.toObject(includeInstance, f),
    pos: (f = msg.getPos()) && proto.vertexvis.protobuf.core.Vector2f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2f}
 */
proto.vertexvis.protobuf.core.AffineTransform2f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.AffineTransform2f;
  return proto.vertexvis.protobuf.core.AffineTransform2f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.AffineTransform2f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2f}
 */
proto.vertexvis.protobuf.core.AffineTransform2f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.LinearTransform2f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.LinearTransform2f.deserializeBinaryFromReader);
      msg.setTransform(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector2f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2f.deserializeBinaryFromReader);
      msg.setPos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.AffineTransform2f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.AffineTransform2f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineTransform2f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransform();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.LinearTransform2f.serializeBinaryToWriter
    );
  }
  f = message.getPos();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector2f.serializeBinaryToWriter
    );
  }
};


/**
 * optional LinearTransform2f transform = 1;
 * @return {?proto.vertexvis.protobuf.core.LinearTransform2f}
 */
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.getTransform = function() {
  return /** @type{?proto.vertexvis.protobuf.core.LinearTransform2f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.LinearTransform2f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.LinearTransform2f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2f} returns this
*/
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.setTransform = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2f} returns this
 */
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.clearTransform = function() {
  return this.setTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.hasTransform = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector2f pos = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector2f}
 */
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.getPos = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2f} returns this
*/
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.setPos = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2f} returns this
 */
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.clearPos = function() {
  return this.setPos(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineTransform2f.prototype.hasPos = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.AffineTransform2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.AffineTransform2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineTransform2d.toObject = function(includeInstance, msg) {
  var f, obj = {
    transform: (f = msg.getTransform()) && proto.vertexvis.protobuf.core.LinearTransform2d.toObject(includeInstance, f),
    pos: (f = msg.getPos()) && proto.vertexvis.protobuf.core.Vector2d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2d}
 */
proto.vertexvis.protobuf.core.AffineTransform2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.AffineTransform2d;
  return proto.vertexvis.protobuf.core.AffineTransform2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.AffineTransform2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2d}
 */
proto.vertexvis.protobuf.core.AffineTransform2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.LinearTransform2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.LinearTransform2d.deserializeBinaryFromReader);
      msg.setTransform(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector2d.deserializeBinaryFromReader);
      msg.setPos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.AffineTransform2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.AffineTransform2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineTransform2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransform();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.LinearTransform2d.serializeBinaryToWriter
    );
  }
  f = message.getPos();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector2d.serializeBinaryToWriter
    );
  }
};


/**
 * optional LinearTransform2d transform = 1;
 * @return {?proto.vertexvis.protobuf.core.LinearTransform2d}
 */
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.getTransform = function() {
  return /** @type{?proto.vertexvis.protobuf.core.LinearTransform2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.LinearTransform2d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.LinearTransform2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2d} returns this
*/
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.setTransform = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2d} returns this
 */
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.clearTransform = function() {
  return this.setTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.hasTransform = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector2d pos = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.getPos = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector2d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2d} returns this
*/
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.setPos = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform2d} returns this
 */
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.clearPos = function() {
  return this.setPos(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineTransform2d.prototype.hasPos = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.AffineTransform3f.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.AffineTransform3f} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineTransform3f.toObject = function(includeInstance, msg) {
  var f, obj = {
    transform: (f = msg.getTransform()) && proto.vertexvis.protobuf.core.LinearTransform3f.toObject(includeInstance, f),
    pos: (f = msg.getPos()) && proto.vertexvis.protobuf.core.Vector3f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3f}
 */
proto.vertexvis.protobuf.core.AffineTransform3f.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.AffineTransform3f;
  return proto.vertexvis.protobuf.core.AffineTransform3f.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.AffineTransform3f} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3f}
 */
proto.vertexvis.protobuf.core.AffineTransform3f.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.LinearTransform3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.LinearTransform3f.deserializeBinaryFromReader);
      msg.setTransform(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector3f;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3f.deserializeBinaryFromReader);
      msg.setPos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.AffineTransform3f.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.AffineTransform3f} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineTransform3f.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransform();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.LinearTransform3f.serializeBinaryToWriter
    );
  }
  f = message.getPos();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector3f.serializeBinaryToWriter
    );
  }
};


/**
 * optional LinearTransform3f transform = 1;
 * @return {?proto.vertexvis.protobuf.core.LinearTransform3f}
 */
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.getTransform = function() {
  return /** @type{?proto.vertexvis.protobuf.core.LinearTransform3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.LinearTransform3f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.LinearTransform3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3f} returns this
*/
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.setTransform = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3f} returns this
 */
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.clearTransform = function() {
  return this.setTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.hasTransform = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3f pos = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.getPos = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3f} returns this
*/
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.setPos = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3f} returns this
 */
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.clearPos = function() {
  return this.setPos(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineTransform3f.prototype.hasPos = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.AffineTransform3d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.AffineTransform3d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineTransform3d.toObject = function(includeInstance, msg) {
  var f, obj = {
    transform: (f = msg.getTransform()) && proto.vertexvis.protobuf.core.LinearTransform3d.toObject(includeInstance, f),
    pos: (f = msg.getPos()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3d}
 */
proto.vertexvis.protobuf.core.AffineTransform3d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.AffineTransform3d;
  return proto.vertexvis.protobuf.core.AffineTransform3d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.AffineTransform3d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3d}
 */
proto.vertexvis.protobuf.core.AffineTransform3d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.LinearTransform3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.LinearTransform3d.deserializeBinaryFromReader);
      msg.setTransform(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setPos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.AffineTransform3d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.AffineTransform3d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.AffineTransform3d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransform();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.LinearTransform3d.serializeBinaryToWriter
    );
  }
  f = message.getPos();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
};


/**
 * optional LinearTransform3d transform = 1;
 * @return {?proto.vertexvis.protobuf.core.LinearTransform3d}
 */
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.getTransform = function() {
  return /** @type{?proto.vertexvis.protobuf.core.LinearTransform3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.LinearTransform3d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.LinearTransform3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3d} returns this
*/
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.setTransform = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3d} returns this
 */
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.clearTransform = function() {
  return this.setTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.hasTransform = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3d pos = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.getPos = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3d} returns this
*/
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.setPos = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.AffineTransform3d} returns this
 */
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.clearPos = function() {
  return this.setPos(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.AffineTransform3d.prototype.hasPos = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Plane.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Plane.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Plane} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Plane.toObject = function(includeInstance, msg) {
  var f, obj = {
    normal: (f = msg.getNormal()) && proto.vertexvis.protobuf.core.Vector3d.toObject(includeInstance, f),
    d: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Plane}
 */
proto.vertexvis.protobuf.core.Plane.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Plane;
  return proto.vertexvis.protobuf.core.Plane.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Plane} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Plane}
 */
proto.vertexvis.protobuf.core.Plane.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.Vector3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Vector3d.deserializeBinaryFromReader);
      msg.setNormal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setD(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Plane.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Plane.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Plane} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Plane.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNormal();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getD();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional Vector3d normal = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.Plane.prototype.getNormal = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Vector3d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Plane} returns this
*/
proto.vertexvis.protobuf.core.Plane.prototype.setNormal = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Plane} returns this
 */
proto.vertexvis.protobuf.core.Plane.prototype.clearNormal = function() {
  return this.setNormal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Plane.prototype.hasNormal = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double d = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.Plane.prototype.getD = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.Plane} returns this
 */
proto.vertexvis.protobuf.core.Plane.prototype.setD = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


goog.object.extend(exports, proto.vertexvis.protobuf.core);
